import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgZoomToFit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M7.8 43 5 40.2l6.2-6.2H6v-4h12v12h-4v-5.2zm32.4 0L34 36.8V42h-4V30h12v4h-5.2l6.2 6.2zM6 18v-4h5.2L5 7.8 7.8 5l6.2 6.2V6h4v12zm24 0V6h4v5.2L40.2 5 43 7.8 36.8 14H42v4z" })
});
export default SvgZoomToFit;
